import '@mdi/font/css/materialdesignicons.css'

export default defineNuxtPlugin(() => {})
